import ReducerRegistry from '../base/redux/ReducerRegistry';
import { CLEAR_ROOM_TIME_LIMIT, HIDE_FINAL_COUNTDOWN, HIDE_ROOM_TIME_LIMIT_WARNING, SET_ROOM_START_TIME, SET_TIME_LIMIT_WARNING_SHOWN, SHOW_FINAL_COUNTDOWN, SHOW_ROOM_TIME_LIMIT_WARNING, UPDATE_COUNTDOWN_SECONDS } from './actionTypes';
import { IRoomTimeLimitState } from './types';
const DEFAULT_STATE = {
    roomStartTime: null,
    showWarningNotification: false,
    showCountdown: false,
    countdownSeconds: 10,
    warningShown: false
};
export { IRoomTimeLimitState };
console.log('🔧 [ROOM TIME LIMIT] Reducer loaded and registered');
ReducerRegistry.register('features/room-time-limit', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SET_ROOM_START_TIME:
            console.log('📝 [ROOM TIME LIMIT REDUCER] SET_ROOM_START_TIME:', action.roomStartTime);
            return {
                ...state,
                roomStartTime: action.roomStartTime
            };
        case SET_TIME_LIMIT_WARNING_SHOWN:
            console.log('📝 [ROOM TIME LIMIT REDUCER] SET_TIME_LIMIT_WARNING_SHOWN');
            return {
                ...state,
                warningShown: true
            };
        case SHOW_ROOM_TIME_LIMIT_WARNING:
            console.log('📝 [ROOM TIME LIMIT REDUCER] SHOW_ROOM_TIME_LIMIT_WARNING');
            return {
                ...state,
                showWarningNotification: true
            };
        case HIDE_ROOM_TIME_LIMIT_WARNING:
            console.log('📝 [ROOM TIME LIMIT REDUCER] HIDE_ROOM_TIME_LIMIT_WARNING');
            return {
                ...state,
                showWarningNotification: false
            };
        case SHOW_FINAL_COUNTDOWN:
            console.log('📝 [ROOM TIME LIMIT REDUCER] SHOW_FINAL_COUNTDOWN');
            return {
                ...state,
                showCountdown: true,
                countdownSeconds: action.seconds || 10
            };
        case HIDE_FINAL_COUNTDOWN:
            console.log('📝 [ROOM TIME LIMIT REDUCER] HIDE_FINAL_COUNTDOWN');
            return {
                ...state,
                showCountdown: false
            };
        case UPDATE_COUNTDOWN_SECONDS:
            return {
                ...state,
                countdownSeconds: action.seconds
            };
        case CLEAR_ROOM_TIME_LIMIT:
            console.log('📝 [ROOM TIME LIMIT REDUCER] CLEAR_ROOM_TIME_LIMIT');
            return DEFAULT_STATE;
        default:
            return state;
    }
});
